// extracted by mini-css-extract-plugin
module.exports = {"image":"jw-z","loaded":"kw-z","placeholder":"lw-z"};